{
  "periods_controls.committed": "{{title}} artık {{range}} aralığında",
  "periods_controls.cancelled": "Taşıma iptal edildi; önceki tarihler geri yüklendi"
}
